module.exports = __webpack_public_path__ + "static/media/link2.c9d9e793.svg";